import { createSlice } from "@reduxjs/toolkit";

export const slice = createSlice({
  name: "businessPartner",

  initialState: {
    businessPartnerModel: null,
  },

  reducers: {
    setBusinessPartnerModel: (state, { payload: businessPartnerModel }) => ({
      ...state,
      businessPartnerModel,
    }),
  },
});

export const { setBusinessPartnerModel } = slice.actions;

export default slice.reducer;

export const getBusinessPartnerModel = (store) => store.businessPartner.businessPartnerModel;